import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const MapIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M14.969 5.00599L8.969 2.99999L3 5.38799V5.39399V21.542L9.031 19.13L15.031 21.136L21 18.747V18.741V2.59399L14.969 5.00599ZM9 17.01V5.14699L9.031 5.13399L15 7.12399V18.987L14.969 19L9 17.01Z"
    />
  </svg>
);

export { MapIcon };
